<template>
  <span
    class="homeLink"
  >
    <df-nav-item
      :href="unionHead.homePageUrl"
      :prefix-icon="bell"
    >
      {{ TLang('企业首页','common') }}
    </df-nav-item>
  </span>
</template>

<script>
export default {
  name: "HomeLink",
  props: {
    unionHead: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      bell: require('../imgs/home.png'),
    };
  },
};
</script>

<style scoped>
.homeLink{
  position: relative;
}
</style>
